import styled from 'styled-components'

import { header5 } from 'styles/texts'

export default styled.label`
  ${header5};
  margin-bottom: 4px;
`



// WEBPACK FOOTER //
// ./src/components/form/Label.js